import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mobile-sidenav',
  templateUrl: './mobile-sidenav.component.html',
  styleUrls: ['./mobile-sidenav.component.scss']
})
export class MobileSidenavComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  @Input() listMenu: any[] = [];
  @Input() menuType: string = 'button'; // 'button' | 'accordination'
  @Input() showLoginProfile: boolean = true;
  @Output() valueChange = new EventEmitter();
  isExpanded: any = 1;

  sideMenu = []

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }

  onClick(item) {
    if (!item.isSelected) {
      this.valueChange.emit(item);
      this.listMenu.forEach((_item) => {
        _item.isSelected = _item.path === item.path;
      });
    }
  }

  onCloseControlled($value) {
    this.isExpanded = this.isExpanded === $value ? null : $value;
  }

  isShowProfile(): boolean {
    return this.showLoginProfile;
  }
  getUserName() {
    let username=localStorage.getItem('profilename');
    if(username== undefined || username == null || username == ''){
      username=localStorage.getItem('userName')
    }
      return username;
  }
  profilename(){
    let username=localStorage.getItem('userName')
    return username;
  }
}
